import * as React from "react";
const DirectionContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") DirectionContext.displayName = "DirectionContext";
function useDirection() {
  const context = React.useContext(DirectionContext);
  return context?.direction ?? "ltr";
}
export {
  DirectionContext,
  useDirection
};
//# sourceMappingURL=DirectionContext.js.map
